import { render, staticRenderFns } from "./BancoHoras.vue?vue&type=template&id=4204d85e&scoped=true"
import script from "./BancoHoras.vue?vue&type=script&lang=js"
export * from "./BancoHoras.vue?vue&type=script&lang=js"
import style0 from "./BancoHoras.vue?vue&type=style&index=0&id=4204d85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204d85e",
  null
  
)

export default component.exports